import React, {Fragment, PureComponent} from 'react';
import {Col, Row} from 'react-bootstrap';

export class SurveyFormComposedInput extends PureComponent {
    render() {
        const { Inputs, Validation } = this.props;

        if (Inputs && Inputs.length) {
            let ret = [];

            Inputs.forEach((component, i) => {
                ret.push(<Row key={i} className="bottom10">
                    <Col xs={12}>
                        {component}
                    </Col>
                </Row>);
            });

            return <Fragment>
                {ret}
                {
                    Validation != null ?
                        <p className="sb-survey-validation-error">{Validation}</p>:
                        null
                }
            </Fragment>;
        }

        return null
    }
}


